import { render, staticRenderFns } from "./SitesView.vue?vue&type=template&id=22bc25d3&scoped=true&"
import script from "./SitesView.vue?vue&type=script&lang=js&"
export * from "./SitesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22bc25d3",
  null
  
)

export default component.exports